import { isValidCNPJ, isValidCPF } from 'utils/functions'
import * as yup from 'yup'

import { VALIDATE } from './validation'

export const SCHEMA = {
  supplierForm: yup
    .object({
      cdCpfResponsavel: yup
        .string()
        .nullable()
        .notRequired()
        .test('cdCpfResponsavel', 'CPF Inválido', (value) => {
          if (isNaN(parseInt(value))) return true
          return isValidCPF(value)
        })
        .max(14, 'CPF Inválido'),

      cdDocto: yup
        .string()
        .when('cdTipoFornecedor', {
          is: 'F',
          then: yup
            .string()
            .test('cdDocto', 'CPF Inválido', (value) => {
              return isValidCPF(value)
            })
            .required('Informe o CPF')
            .max(14, 'CPF Inválido')
        })
        .when('cdTipoFornecedor', {
          is: 'J',
          then: yup
            .string()
            .test('cdDocto', 'CNPJ Inválido', (value) => {
              return isValidCNPJ(value)
            })
            .required('Informe o CNPJ')
            .max(18, 'CNPJ Inválido')
        })
        .when('cdTipoFornecedor', {
          is: 'E',
          then: yup
            .string()
            .nullable()
            .max(20, 'Passaport Inválido')
        }),

      /*
  cdDocto: yup
    .string()
    .test("cdDocto", "CPF/CNPJ Inválido", (value) => {
      if (isNaN(parseInt(value))) return true
      if (value.length < 15) return isValidCPF(value)
      return isValidCNPJ(value)
    })
    .required("Informe CPF / CNPJ / Passaporte")
    .max(18, "CNPJ Inválido"),
    */
      cdTipoFornecedor: yup.string().required('Informe o tipo do Fornecedor'),
      contatosComercial: VALIDATE.supplierContacts,
      contatosImportacao: VALIDATE.supplierContacts,
      contatosSeguranca: VALIDATE.supplierContacts,
      contatosTrabalhista: VALIDATE.supplierContacts,
      nmFornecedor: yup
        .string()
        .min(10, 'Mínimo 10 caracteres')
        .max(100, 'Máximo 100 caracteres')
        .required('Informe o nome'),
      nmResponsavel: yup
        .string()
        .min(5, 'Mínimo 5 caracteres')
        .max(50, 'Máximo 50 caracteres')
        .required('Informe nome do responsável.'),
      // nuCelResponsavel: yup
      //   .string()
      //   .transform((value) => value.replace(/[^\d]/g, ''))
      //   .test('len', 'Celular inválido.', (value) => {
      //     if (!value || value.length === 0 || value.length >= 10) return true
      //     return false
      //   }),
      nuCelular: yup
        .string()
        .transform((value) => value.replace(/[^\d]/g, ''))
        .test('len', 'Celular inválido.', (value) => {
          if (!value || value.length === 0 || value.length >= 11) return true
          return false
        }),
      // nuNumero: yup
      //   .string()
      //   .max(10, 'Máximo 10 caracteres')
      //   .required('Informe o número.'),
      // nuTelefone: yup
      //   .string()
      //   .required('Informe número de telefone.')
      //   .transform((value) => value.replace(/[^\d]/g, ''))
      //   .min(10, 'Telefone inválido.'),
      sgEstado: yup
        .string()
        .min(2, 'Estado inválido.')
        .max(2, 'Máximo 2 lestras')
        .required('Informe o estado.'),
      sgPais: yup
        .string()
        .min(2, 'País inválido')
        .max(2, 'Máximo 2 lestras')
        .test(
          'should contain only uppercase letters',
          'País deve apenas conter letras',
          (value) => {
            return !!value.match(/([a-zA-Z]{2})/)
          }
        )
        .required('Informe o país'),
      txBairro: yup
        .string()
        .min(2, 'Bairro inválido.')
        .max(50, 'Máximo 50 caracteres')
        .required('Informe o bairro.'),
      txCidade: yup
        .string()
        .min(3, 'Cidade inválida.')
        .max(50, 'Máximo 50 caracteres')
        .required('Informe a cidade.'),
      // txCno: yup
      //   .string()
      //   .max(50, "Máximo 50 caracteres")
      //   .required("Informe o CNO."),
      txComplemento: yup.string().nullable().max(50, 'Máximo 50 caracteres'),
      txEmailResponsavel: yup
        .string()
        //.email('E-mail inválido.')
        .matches(/^[^\s@]+@[^\s@]+\.[^\s@]+$/, 'Digite um email válido') 
        .max(50, 'Máximo 50 caracteres')
        .required('Informe um e-mail.'),
      txEndereco: yup
        .string()
        .min(5, 'Mínimo 5 caracteres')
        .max(50, 'Máximo 50 caracteres')
        .required('Informe o endereço.')
    })
    .required()
}
